// import React, { useEffect, useState } from 'react';
// import * as UTIF from 'utif';

// export default function FileViewer({ base64Data, contentType }) {
//     const [fileUrl, setFileUrl] = useState(null);

//     useEffect(() => {
//         if (!base64Data || !contentType) return;

//         const cleanedBase64 = base64Data.replace(/\s+/g, '');

//         if (contentType === 'image/tiff' || contentType === 'image/tif') {
//             try {
//                 const binary = atob(cleanedBase64);
//                 const bytes = new Uint8Array([...binary].map(c => c.charCodeAt(0)));

//                 const ifds = UTIF.decode(bytes);
//                 UTIF.decodeImages(bytes, ifds);
//                 const rgba = UTIF.toRGBA8(ifds[0]);

//                 const canvas = document.createElement('canvas');
//                 canvas.width = ifds[0].width;
//                 canvas.height = ifds[0].height;
//                 const ctx = canvas.getContext('2d');
//                 const imageData = ctx.createImageData(canvas.width, canvas.height);
//                 imageData.data.set(rgba);
//                 ctx.putImageData(imageData, 0, 0);

//                 const imgUrl = canvas.toDataURL('image/png');
//                 setFileUrl(imgUrl);
//             } catch (err) {
//                 console.error('Error converting TIFF to image:', err);
//             }
//         } else {
//             try {
//                 const byteCharacters = atob(cleanedBase64);
//                 const byteNumbers = new Array(byteCharacters.length)
//                     .fill(0)
//                     .map((_, i) => byteCharacters.charCodeAt(i));
//                 const byteArray = new Uint8Array(byteNumbers);
//                 const blob = new Blob([byteArray], { type: contentType });
//                 const url = URL.createObjectURL(blob);
//                 setFileUrl(url);
//             } catch (err) {
//                 console.error('Error decoding file:', err);
//             }
//         }
//     }, [base64Data, contentType]);

//     if (!fileUrl) return <div>Loading document...</div>;

//     if (contentType === 'application/pdf') {
//         return (
//             <div>
//                 <embed
//                     src={`${fileUrl}#toolbar=0&navpanes=0&scrollbar=0`}
//                     type="application/pdf"
//                     width="100%"
//                     height="600px"
//                     style={{ border: 'none' }}
//                 />
//                 <div style={{ marginTop: '10px' }}>
//                     <a href={fileUrl} download="document.pdf">Download PDF</a>
//                 </div>
//             </div>
//         );
//     }
//     if (['image/png', 'image/jpeg', 'image/tiff', 'image/tif'].includes(contentType)) {
//         return <img src={fileUrl} alt="Document" style={{ width: '100%', maxHeight: '600px' }} />;
//     }

//     if (contentType === 'application/rtf') {
//         return (
//             <div>
//                 <p>This is an RTF document. It might not display in the browser, but you can download it:</p>
//                 <iframe
//                     src={fileUrl}
//                     width="100%"
//                     height="400px"
//                     title="RTF Preview"
//                     style={{ border: '1px solid #ccc' }}
//                 />
//                 <br />
//                 <a
//                     href={fileUrl}
//                     download="document.rtf"
//                     target="_blank"
//                     rel="noopener noreferrer"
//                     style={{
//                         display: 'inline-block',
//                         marginTop: '10px',
//                         padding: '8px 16px',
//                         backgroundColor: '#007bff',
//                         color: '#fff',
//                         textDecoration: 'none',
//                         borderRadius: '4px'
//                     }}
//                 >
//                     Download RTF File
//                 </a>
//             </div>
//         );
//     }

//     return null;
// }



// import React, { useEffect, useState } from 'react';
// import * as UTIF from 'utif';

// export default function FileViewer({ base64Data, contentType }) {
//     const [fileUrl, setFileUrl] = useState(null);

//     useEffect(() => {
//         if (!base64Data || !contentType) return;

//         const cleanedBase64 = base64Data.replace(/\s+/g, '');

//         if (contentType === 'image/tiff' || contentType === 'image/tif') {
//             try {
//                 const binary = atob(cleanedBase64);
//                 const bytes = new Uint8Array(binary.length);
//                 for (let i = 0; i < binary.length; i++) {
//                     bytes[i] = binary.charCodeAt(i);
//                 }

//                 const ifds = UTIF.decode(bytes);
//                 if (!ifds || ifds.length === 0) {
//                     throw new Error('No IFDs found in TIFF data.');
//                 }

//                 // Fix: Use decodeImage (singular) for v2
//                 UTIF.decodeImage(bytes, ifds[0]);
//                 const rgba = UTIF.toRGBA8(ifds[0]);

//                 const canvas = document.createElement('canvas');
//                 canvas.width = ifds[0].width;
//                 canvas.height = ifds[0].height;
//                 const ctx = canvas.getContext('2d');
//                 const imageData = ctx.createImageData(canvas.width, canvas.height);
//                 imageData.data.set(rgba);
//                 ctx.putImageData(imageData, 0, 0);

//                 const imgUrl = canvas.toDataURL('image/png');
//                 setFileUrl(imgUrl);
//             } catch (err) {
//                 console.error('Error converting TIFF to image:', err);
//                 setFileUrl(null);
//             }
//         } else {
//             try {
//                 const byteCharacters = atob(cleanedBase64);
//                 const byteNumbers = new Array(byteCharacters.length);
//                 for (let i = 0; i < byteCharacters.length; i++) {
//                     byteNumbers[i] = byteCharacters.charCodeAt(i);
//                 }
//                 const byteArray = new Uint8Array(byteNumbers);
//                 const blob = new Blob([byteArray], { type: contentType });
//                 const url = URL.createObjectURL(blob);
//                 setFileUrl(url);
//             } catch (err) {
//                 console.error('Error decoding file:', err);
//                 setFileUrl(null);
//             }
//         }
//     }, [base64Data, contentType]);

//     if (!fileUrl) return <div>Loading document...</div>;

//     if (contentType === 'application/pdf') {
//         return (
//             <div>
//                 <embed
//                     src={`${fileUrl}#toolbar=0&navpanes=0&scrollbar=0`}
//                     type="application/pdf"
//                     width="100%"
//                     height="600px"
//                     style={{ border: 'none' }}
//                 />
//                 <div style={{ marginTop: '10px' }}>
//                     <a href={fileUrl} download="document.pdf">Download PDF</a>
//                 </div>
//             </div>
//         );
//     }

//     if (['image/png', 'image/jpeg', 'image/tiff', 'image/tif'].includes(contentType)) {
//         return <img src={fileUrl} alt="Document" style={{ width: '100%', maxHeight: '1122px' }} />;
//     }

//     if (contentType === 'application/rtf') {
//         return (
//             <div>
//                 <p>This is an RTF document. It might not display in the browser, but you can download it:</p>
//                 <iframe
//                     src={fileUrl}
//                     width="100%"
//                     height="400px"
//                     title="RTF Preview"
//                     style={{ border: '1px solid #ccc' }}
//                 />
//                 <br />
//                 <a
//                     href={fileUrl}
//                     download="document.rtf"
//                     target="_blank"
//                     rel="noopener noreferrer"
//                     style={{
//                         display: 'inline-block',
//                         marginTop: '10px',
//                         padding: '8px 16px',
//                         backgroundColor: '#007bff',
//                         color: '#fff',
//                         textDecoration: 'none',
//                         borderRadius: '4px'
//                     }}
//                 >
//                     Download RTF File
//                 </a>
//             </div>
//         );
//     }

//     return null;
// }

// import React, { useEffect, useState } from 'react';
// import * as UTIF from 'utif';
// import { Document, Page, pdfjs } from 'react-pdf';
// import { isIOS } from 'mobile/helpers';

// pdfjs.GlobalWorkerOptions.workerSrc = `https://unpkg.com/pdfjs-dist@2.12.313/build/pdf.worker.min.js`;

// export default function FileViewer({ base64Data, contentType }) {
//     const [fileUrl, setFileUrl] = useState(null);
//     const [numPages, setNumPages] = useState(null);
//     const [error, setError] = useState(false);

//     useEffect(() => {
//         if (!base64Data || !contentType) return;

//         setError(false);
//         const cleanedBase64 = base64Data.replace(/\s+/g, '');

//         if (contentType.startsWith('image/tiff')) {
//             try {
//                 // safer base64 decoding
//                 const byteCharacters = atob(cleanedBase64);
//                 const bytes = new Uint8Array(byteCharacters.length);
//                 for (let i = 0; i < byteCharacters.length; i++) {
//                     bytes[i] = byteCharacters.charCodeAt(i);
//                 }

//                 const ifds = UTIF.decode(bytes);
//                 if (ifds.length === 0) throw new Error('No IFDs found in TIFF');

//                 UTIF.decodeImage(bytes, ifds[0]);
//                 const rgba = UTIF.toRGBA8(ifds[0]);

//                 const canvas = document.createElement('canvas');
//                 canvas.width = ifds[0].width;
//                 canvas.height = ifds[0].height;
//                 const ctx = canvas.getContext('2d');
//                 const imageData = ctx.createImageData(canvas.width, canvas.height);
//                 imageData.data.set(rgba);
//                 ctx.putImageData(imageData, 0, 0);

//                 const imgUrl = canvas.toDataURL('image/png');
//                 setFileUrl(imgUrl);
//             } catch (err) {
//                 console.error('Error converting TIFF:', err);
//                 setError(true);
//             }
//         } else {
//             try {
//                 const byteCharacters = atob(cleanedBase64);
//                 const byteNumbers = Array.from(byteCharacters, c => c.charCodeAt(0));
//                 const byteArray = new Uint8Array(byteNumbers);
//                 const blob = new Blob([byteArray], { type: contentType });
//                 const url = URL.createObjectURL(blob);
//                 setFileUrl(url);
//             } catch (err) {
//                 console.error('Error decoding base64:', err);
//                 setError(true);
//             }
//         }
//     }, [base64Data, contentType]);

//     if (error) {
//         return (
//             <div style={{ padding: '20px', color: 'red', textAlign: 'center' }}>
//                 Failed to load the file.
//             </div>
//         );
//     }

//     if (!fileUrl) {
//         return <div style={{ padding: '20px' }}>Loading document...</div>;
//     }

//     // PDF preview
//     if (contentType === 'application/pdf') {
//         if (isIOS) {
//             return (
//                 <div style={{ padding: '20px', textAlign: 'center' }}>
//                     <p>This PDF can't be previewed inline on iOS. Tap below to open it:</p>
//                     <a
//                         href={fileUrl}
//                         target="_blank"
//                         rel="noopener noreferrer"
//                         style={{
//                             display: 'inline-block',
//                             padding: '10px 20px',
//                             backgroundColor: '#007bff',
//                             color: '#fff',
//                             textDecoration: 'none',
//                             borderRadius: '4px'
//                         }}
//                     >
//                         Open PDF
//                     </a>
//                 </div>
//             );
//         }

//         return (
//             <div style={{ width: '100%', maxWidth: '100%', overflowX: 'auto', padding: '10px' }}>
//                 <Document
//                     file={fileUrl}
//                     onLoadSuccess={({ numPages }) => setNumPages(numPages)}
//                     loading={<div>Loading PDF...</div>}
//                     error={<div>Unable to load PDF.</div>}
//                 >
//                     {Array.from(new Array(numPages), (_, index) => (
//                         <Page
//                             key={`page_${index + 1}`}
//                             pageNumber={index + 1}
//                             width={Math.min(window.innerWidth - 20, 600)}
//                         />
//                     ))}
//                 </Document>
//                 <div style={{ textAlign: 'center', marginTop: '10px' }}>
//                     <a
//                         href={fileUrl}
//                         download="document.pdf"
//                         style={{
//                             display: 'inline-block',
//                             padding: '10px 20px',
//                             backgroundColor: '#28a745',
//                             color: '#fff',
//                             textDecoration: 'none',
//                             borderRadius: '4px'
//                         }}
//                     >
//                         Download PDF
//                     </a>
//                 </div>
//             </div>
//         );
//     }

//     // Image preview
//     if (contentType.startsWith('image/')) {
//         return (
//             <div style={{ padding: '10px', textAlign: 'center' }}>
//                 <img
//                     src={fileUrl}
//                     alt="Document"
//                     style={{
//                         width: '100%',
//                         maxWidth: '100%',
//                         maxHeight: '80vh',
//                         objectFit: 'contain',
//                         border: '1px solid #ccc',
//                         borderRadius: '4px'
//                     }}
//                 />
//             </div>
//         );
//     }

//     // Unsupported file types
//     return (
//         <div style={{ padding: '20px', textAlign: 'center' }}>
//             <p>Preview not supported. Please download the file:</p>
//             <a
//                 href={fileUrl}
//                 download
//                 style={{
//                     display: 'inline-block',
//                     padding: '10px 20px',
//                     backgroundColor: '#17a2b8',
//                     color: '#fff',
//                     textDecoration: 'none',
//                     borderRadius: '4px'
//                 }}
//             >
//                 Download File
//             </a>
//         </div>
//     );
// }






// import React, { useEffect, useState } from 'react';
// import * as UTIF from 'utif';
// import { Document, Page, pdfjs } from 'react-pdf';

// pdfjs.GlobalWorkerOptions.workerSrc = `https://unpkg.com/pdfjs-dist@2.12.313/build/pdf.worker.min.js`;

// export default function FileViewer({ base64Data, contentType, fileName = "document" }) {
//     const [fileUrl, setFileUrl] = useState(null);
//     const [blob, setBlob] = useState(null);
//     const [numPages, setNumPages] = useState(null);
//     const [error, setError] = useState(false);

//     useEffect(() => {
//         if (!base64Data || !contentType) return;

//         setError(false);
//         setFileUrl(null);
//         setBlob(null);

//         const cleanedBase64 = base64Data.replace(/\s+/g, '');

//         if (contentType.startsWith('image/tiff')) {
//             try {
//                 const byteCharacters = atob(cleanedBase64);
//                 const bytes = new Uint8Array(byteCharacters.length);
//                 for (let i = 0; i < byteCharacters.length; i++) {
//                     bytes[i] = byteCharacters.charCodeAt(i);
//                 }

//                 const ifds = UTIF.decode(bytes);
//                 if (ifds.length === 0) throw new Error('No IFDs found in TIFF');

//                 UTIF.decodeImage(bytes, ifds[0]);
//                 const rgba = UTIF.toRGBA8(ifds[0]);

//                 const canvas = document.createElement('canvas');
//                 canvas.width = ifds[0].width;
//                 canvas.height = ifds[0].height;
//                 const ctx = canvas.getContext('2d');
//                 const imageData = ctx.createImageData(canvas.width, canvas.height);
//                 imageData.data.set(rgba);
//                 ctx.putImageData(imageData, 0, 0);

//                 const imgUrl = canvas.toDataURL('image/png');
//                 setFileUrl(imgUrl);

//                 fetch(imgUrl)
//                     .then(res => res.blob())
//                     .then(b => setBlob(b));
//             } catch (err) {
//                 console.error('Error converting TIFF:', err);
//                 setError(true);
//             }
//         } else {
//             try {
//                 const byteCharacters = atob(cleanedBase64);
//                 const byteNumbers = Array.from(byteCharacters, c => c.charCodeAt(0));
//                 const byteArray = new Uint8Array(byteNumbers);
//                 const blob = new Blob([byteArray], { type: contentType });
//                 const url = URL.createObjectURL(blob);
//                 setFileUrl(url);
//                 setBlob(blob);
//             } catch (err) {
//                 console.error('Error decoding base64:', err);
//                 setError(true);
//             }
//         }
//     }, [base64Data, contentType]);

//     const handleDownload = () => {
//         if (!blob) return;
//         const url = URL.createObjectURL(blob);
//         const link = document.createElement('a');
//         link.href = url;
//         const extension = contentType.split('/')[1].split('+')[0];
//         link.download = `${fileName}.${extension}`;
//         document.body.appendChild(link);
//         link.click();
//         document.body.removeChild(link);
//         URL.revokeObjectURL(url);
//     };

//     if (error) {
//         return (
//             <div style={{ padding: '20px', color: 'red', textAlign: 'center' }}>
//                 Failed to load the file.
//             </div>
//         );
//     }

//     if (!fileUrl) {
//         return <div style={{ padding: '20px' }}>Loading document...</div>;
//     }

//     // PDF preview
//     if (contentType === 'application/pdf') {
//         return (
//             <div style={{ width: '100%', maxWidth: '100%', overflowX: 'auto', padding: '10px' }}>
//                 <Document
//                     file={fileUrl}
//                     onLoadSuccess={({ numPages }) => setNumPages(numPages)}
//                     loading={<div>Loading PDF...</div>}
//                     error={<div>Unable to load PDF.</div>}
//                 >
//                     {Array.from(new Array(numPages), (_, index) => (
//                         <div
//                             key={`page_wrapper_${index + 1}`}
//                             style={{
//                                 width: '100%',
//                                 maxWidth: '100%',
//                                 margin: '0 auto',
//                                 marginBottom: '20px',
//                                 boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
//                                 border: '1px solid #ccc',
//                                 borderRadius: '4px',
//                                 overflow: 'auto',
//                                 backgroundColor: '#fff'
//                             }}
//                         >
//                             <Page
//                                 pageNumber={index + 1}
//                                 width={Math.min(window.innerWidth - 40, 800)}
//                             />
//                         </div>
//                     ))}
//                 </Document>

//                 {/* <div style={{ textAlign: 'center', marginTop: '10px' }}>
//                     <button
//                         onClick={handleDownload}
//                         style={{
//                             padding: '10px 20px',
//                             backgroundColor: '#28a745',
//                             color: '#fff',
//                             border: 'none',
//                             borderRadius: '4px',
//                             cursor: 'pointer'
//                         }}
//                     >
//                         Download PDF
//                     </button>
//                 </div> */}
//             </div>
//         );
//     }

//     if (contentType.startsWith('image/')) {
//         return (
//             <div style={{ padding: '10px', textAlign: 'center' }}>
//                 <img
//                     src={fileUrl}
//                     alt="Document"
//                     style={{
//                         width: '100%',
//                         margin: 'auto',
//                         maxWidth: '100%',
//                         maxHeight: '80vh',
//                         objectFit: 'cover',
//                         border: '1px solid #ccc',
//                         borderRadius: '4px'
//                     }}
//                 />
//                 {/* <div style={{ marginTop: '10px' }}>
//                     <button
//                         onClick={handleDownload}
//                         style={{
//                             padding: '10px 20px',
//                             backgroundColor: '#28a745',
//                             color: '#fff',
//                             border: 'none',
//                             borderRadius: '4px',
//                             cursor: 'pointer'
//                         }}
//                     >
//                         Download Image
//                     </button>
//                 </div> */}
//             </div>
//         );
//     }

//     return (
//         <div style={{ padding: '20px', textAlign: 'center' }}>
//             <p>Preview not supported. Please download the file:</p>
//             <button
//                 onClick={handleDownload}
//                 style={{
//                     padding: '10px 20px',
//                     backgroundColor: '#17a2b8',
//                     color: '#fff',
//                     border: 'none',
//                     borderRadius: '4px',
//                     cursor: 'pointer'
//                 }}
//             >
//                 Download File
//             </button>
//         </div>
//     );
// }



// import React, { useEffect, useState } from 'react';
// import * as UTIF from 'utif';
// import { isIOS } from 'mobile/helpers';
// import { Document, Page, pdfjs } from 'react-pdf';

// pdfjs.GlobalWorkerOptions.workerSrc = `https://unpkg.com/pdfjs-dist@2.12.313/build/pdf.worker.min.js`;


// export default function FileViewer({ base64Data, contentType, fileName = "document" }) {
//     const [fileUrl, setFileUrl] = useState(null);
//     const [blob, setBlob] = useState(null);
//     const [numPages, setNumPages] = useState(null);
//     const [currentPage, setCurrentPage] = useState(1);
//     const [error, setError] = useState(false);

//     useEffect(() => {
//         if (!base64Data || !contentType) return;

//         setError(false);
//         setFileUrl(null);
//         setBlob(null);
//         setNumPages(null);
//         setCurrentPage(1);

//         const cleanedBase64 = base64Data.replace(/\s+/g, '');

//         if (contentType.startsWith('image/tiff')) {
//             try {
//                 const byteCharacters = atob(cleanedBase64);
//                 const bytes = new Uint8Array(byteCharacters.length);
//                 for (let i = 0; i < byteCharacters.length; i++) {
//                     bytes[i] = byteCharacters.charCodeAt(i);
//                 }

//                 const ifds = UTIF.decode(bytes);
//                 if (ifds.length === 0) throw new Error('No IFDs found in TIFF');

//                 UTIF.decodeImage(bytes, ifds[0]);
//                 const rgba = UTIF.toRGBA8(ifds[0]);

//                 const canvas = document.createElement('canvas');
//                 const width = ifds[0].width;
//                 const height = ifds[0].height;

//                 const maxPixels = 16777216;
//                 if (width * height > maxPixels) throw new Error('TIFF image too large for iOS WebView');

//                 canvas.width = width;
//                 canvas.height = height;
//                 const ctx = canvas.getContext('2d');
//                 const imageData = ctx.createImageData(width, height);
//                 imageData.data.set(rgba);
//                 ctx.putImageData(imageData, 0, 0);

//                 const imgUrl = canvas.toDataURL('image/png');
//                 setFileUrl(imgUrl);

//                 fetch(imgUrl)
//                     .then(res => res.blob())
//                     .then(b => setBlob(b));
//             } catch (err) {
//                 console.error('Error converting TIFF:', err);
//                 setError(true);
//             }
//         } else {
//             try {
//                 const byteCharacters = atob(cleanedBase64);
//                 const byteNumbers = Array.from(byteCharacters, c => c.charCodeAt(0));
//                 const byteArray = new Uint8Array(byteNumbers);
//                 const blob = new Blob([byteArray], { type: contentType });
//                 const url = URL.createObjectURL(blob);
//                 setFileUrl(url);
//                 setBlob(blob);
//             } catch (err) {
//                 console.error('Error decoding base64:', err);
//                 setError(true);
//             }
//         }
//     }, [base64Data, contentType]);

//     const handleDownload = () => {
//         if (!blob) return;
//         const url = URL.createObjectURL(blob);
//         const link = document.createElement('a');
//         const extension = contentType.split('/')[1].split('+')[0];
//         link.href = url;
//         link.download = `${fileName}.${extension}`;
//         document.body.appendChild(link);
//         link.click();
//         document.body.removeChild(link);
//         URL.revokeObjectURL(url);
//     };

//     if (error) {
//         return (
//             <div style={{ padding: '20px', color: 'red', textAlign: 'center' }}>
//                 Failed to load the file.
//             </div>
//         );
//     }

//     if (!fileUrl) {
//         return <div style={{ padding: '20px' }}>Loading document...</div>;
//     }

//     if (contentType === 'application/pdf' && isIOS) {
//         return (
//             <div style={{ padding: '10px' }}>
//                 <Document
//                     file={fileUrl}
//                     onLoadSuccess={({ numPages }) => {
//                         setNumPages(numPages);
//                         setCurrentPage(1);
//                     }}
//                     loading={<div>Loading PDF...</div>}
//                     error={<div>Unable to load PDF.</div>}
//                 >
//                     <Page
//                         pageNumber={currentPage}
//                         width={Math.min(window.innerWidth - 40, 800)}
//                     />
//                 </Document>

//                 <div style={{ textAlign: 'center', marginTop: '10px' }}>
//                     <button type='button' disabled={currentPage <= 1} onClick={() => setCurrentPage(p => p - 1)}>Previous</button>
//                     <span style={{ margin: '0 10px' }}>{currentPage} / {numPages}</span>
//                     <button type='button' disabled={currentPage >= numPages} onClick={() => setCurrentPage(p => p + 1)}>Next</button>
//                 </div>
//             </div>
//         );
//     }



//     if (contentType === 'application/pdf') {
//         return (
//             <div style={{ width: '100%', maxWidth: '100%', overflowX: 'auto', padding: '10px' }}>
//                 <Document
//                     file={fileUrl}
//                     onLoadSuccess={({ numPages }) => setNumPages(numPages)}
//                     loading={<div>Loading PDF...</div>}
//                     error={<div>Unable to load PDF.</div>}
//                 >
//                     {Array.from(new Array(numPages), (_, index) => (
//                         <div
//                             key={`page_wrapper_${index + 1}`}
//                             style={{
//                                 width: '100%',
//                                 maxWidth: '100%',
//                                 margin: '0 auto 20px',
//                                 boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
//                                 border: '1px solid #ccc',
//                                 borderRadius: '4px',
//                                 overflow: 'auto',
//                                 backgroundColor: '#fff'
//                             }}
//                         >
//                             <Page
//                                 pageNumber={index + 1}
//                                 width={Math.min(window.innerWidth - 40, 800)}
//                             />
//                         </div>
//                     ))}
//                 </Document>
//             </div>
//         );
//     }

//     if (contentType.startsWith('image/')) {
//         return (
//             <div style={{ padding: '10px', textAlign: 'center' }}>
//                 <img
//                     src={fileUrl}
//                     alt="Document"
//                     style={{
//                         width: '100%',
//                         margin: 'auto',
//                         maxWidth: '100%',
//                         maxHeight: '80vh',
//                         objectFit: 'cover',
//                         border: '1px solid #ccc',
//                         borderRadius: '4px'
//                     }}
//                 />
//             </div>
//         );
//     }

//     return (
//         <div style={{ padding: '20px', textAlign: 'center' }}>
//             <p>Preview not supported. Please download the file:</p>
//             <button
//                 type='button'
//                 onClick={handleDownload}
//                 style={{
//                     padding: '10px 20px',
//                     backgroundColor: '#17a2b8',
//                     color: '#fff',
//                     border: 'none',
//                     borderRadius: '4px',
//                     cursor: 'pointer'
//                 }}
//             >
//                 Download File
//             </button>
//         </div>
//     );
// }

import React, { useEffect, useState } from 'react';
import * as UTIF from 'utif';
import { isIOS } from 'mobile/helpers';
import { Document, Page, pdfjs } from 'react-pdf';

pdfjs.GlobalWorkerOptions.workerSrc = `https://unpkg.com/pdfjs-dist@2.12.313/build/pdf.worker.min.js`;

export default function FileViewer({ base64Data, contentType, fileName = "document" }) {
    const [fileUrl, setFileUrl] = useState(null);
    const [blob, setBlob] = useState(null);
    const [numPages, setNumPages] = useState(null);
    const [currentPage, setCurrentPage] = useState(1);
    const [error, setError] = useState(false);

    useEffect(() => {
        if (!base64Data || !contentType) return;

        setError(false);
        setFileUrl(null);
        setBlob(null);
        setNumPages(null);
        setCurrentPage(1);

        const cleanedBase64 = base64Data.replace(/\s+/g, '');

        if (contentType.startsWith('image/tiff')) {
            try {
                const byteCharacters = atob(cleanedBase64);
                const bytes = new Uint8Array(byteCharacters.length);
                for (let i = 0; i < byteCharacters.length; i++) {
                    bytes[i] = byteCharacters.charCodeAt(i);
                }

                const ifds = UTIF.decode(bytes);
                if (ifds.length === 0) throw new Error('No IFDs found in TIFF');

                UTIF.decodeImage(bytes, ifds[0]);
                const rgba = UTIF.toRGBA8(ifds[0]);
                const canvas = document.createElement('canvas');
                const width = ifds[0].width;
                const height = ifds[0].height;
                const maxPixels = 16777216;
                if (width * height > maxPixels) throw new Error('TIFF too large for iOS');

                canvas.width = width;
                canvas.height = height;
                const ctx = canvas.getContext('2d');
                const imageData = ctx.createImageData(width, height);
                imageData.data.set(rgba);
                ctx.putImageData(imageData, 0, 0);

                const imgUrl = canvas.toDataURL('image/png');
                setFileUrl(imgUrl);
                fetch(imgUrl)
                    .then(res => res.blob())
                    .then(b => setBlob(b));
            } catch (err) {
                console.error('Error converting TIFF:', err);
                setError(true);
            }
        } else {
            try {
                const byteCharacters = atob(cleanedBase64);
                const byteNumbers = Array.from(byteCharacters, c => c.charCodeAt(0));
                const byteArray = new Uint8Array(byteNumbers);
                const blob = new Blob([byteArray], { type: contentType });
                const url = URL.createObjectURL(blob);
                setFileUrl(url);
                setBlob(blob);
            } catch (err) {
                console.error('Error decoding base64:', err);
                setError(true);
            }
        }

        return () => {
            if (fileUrl) URL.revokeObjectURL(fileUrl);
        };
    }, [base64Data, contentType]);

    const handleDownload = () => {
        if (!blob) return;
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        const extension = contentType.split('/')[1].split('+')[0];
        link.href = url;
        link.download = `${fileName}.${extension}`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
    };

    if (error) {
        return <div style={{ padding: '20px', color: 'red', textAlign: 'center' }}>Failed to load the file.</div>;
    }

    if (!fileUrl) {
        return <div style={{ padding: '20px' }}>Loading document...</div>;
    }

    if (contentType === 'application/pdf' && isIOS) {
        return (
            <div style={{ padding: '10px', textAlign: 'center' }}>
                <Document
                    file={fileUrl}
                    onLoadSuccess={({ numPages }) => {
                        setNumPages(numPages);
                        setCurrentPage(1);
                    }}
                    loading={<div>Loading PDF...</div>}
                    error={<div>Unable to load PDF.</div>}
                >
                    <Page
                        pageNumber={currentPage}
                        width={Math.min(window.innerWidth - 40, 800)}
                        renderMode="canvas"
                    />
                </Document>

                {numPages && (
                    <div style={{ marginTop: '10px' }}>
                        <button
                            type='button'
                            disabled={currentPage <= 1}
                            onClick={() => setCurrentPage(p => p - 1)}
                        >
                            Previous
                        </button>
                        <span style={{ margin: '0 10px' }}>{currentPage} / {numPages}</span>
                        <button
                            type='button'
                            disabled={currentPage >= numPages}
                            onClick={() => setCurrentPage(p => p + 1)}
                        >
                            Next
                        </button>
                    </div>
                )}
            </div>
        );
    }

    if (contentType === 'application/pdf') {
        return (
            <div style={{ width: '100%', maxWidth: '100%', overflowX: 'auto', padding: '10px' }}>
                <Document
                    file={fileUrl}
                    onLoadSuccess={({ numPages }) => setNumPages(numPages)}
                    loading={<div>Loading PDF...</div>}
                    error={<div>Unable to load PDF.</div>}
                >
                    {Array.from(new Array(numPages), (_, index) => (
                        <div
                            key={`page_${index + 1}`}
                            style={{
                                width: '100%',
                                maxWidth: '100%',
                                margin: '0 auto 20px',
                                boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                                border: '1px solid #ccc',
                                borderRadius: '4px',
                                overflow: 'auto',
                                backgroundColor: '#fff'
                            }}
                        >
                            <Page
                                pageNumber={index + 1}
                                width={Math.min(window.innerWidth - 40, 800)}
                                renderMode="canvas"
                            />
                        </div>
                    ))}
                </Document>
            </div>
        );
    }

    if (contentType.startsWith('image/')) {
        return (
            <div style={{ padding: '10px', textAlign: 'center' }}>
                <img
                    src={fileUrl}
                    alt="Document"
                    style={{
                        width: '100%',
                        margin: 'auto',
                        maxWidth: '100%',
                        maxHeight: '80vh',
                        objectFit: 'contain',
                        border: '1px solid #ccc',
                        borderRadius: '4px'
                    }}
                />
            </div>
        );
    }

    return (
        <div style={{ padding: '20px', textAlign: 'center' }}>
            <p>Preview not supported. Please download the file:</p>
            <button
                type='button'
                onClick={handleDownload}
                style={{
                    padding: '10px 20px',
                    backgroundColor: '#17a2b8',
                    color: '#fff',
                    border: 'none',
                    borderRadius: '4px',
                    cursor: 'pointer'
                }}
            >
                Download File
            </button>
        </div>
    );
}
